import { render, staticRenderFns } from "./modify-item.vue?vue&type=template&id=90a4801a&scoped=true&"
import script from "./modify-item.vue?vue&type=script&lang=js&"
export * from "./modify-item.vue?vue&type=script&lang=js&"
import style0 from "./modify-item.vue?vue&type=style&index=0&lang=css&"
import style1 from "./modify-item.vue?vue&type=style&index=1&id=90a4801a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a4801a",
  null
  
)

export default component.exports